module.exports = __webpack_public_path__ + "8205d889b83299d4ef23b25c42ba82e0.fbx";